//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { focus, willChange } from '~/helpers/directives';
import SfSelectOption from './internal/SfSelectOption.vue';

Vue.component('SfSelectOption', SfSelectOption);
export default {
  name: 'SfSelect',
  directives: { focus, willChange },
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'This field is not correct.',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'pure'].includes(value),
    },
  },
  methods: {
    changeHandler(event) {
      this.$emit('input', event.target.value);
    },
  },
};
